var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKnowledgeTransfer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Knowledge_transfer",
    "data-name": "Knowledge transfer",
    transform: "translate(0 -99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "brain-solid",
    d: "M7.538,0A2.3,2.3,0,0,1,9.832,2.294V18.681a2.294,2.294,0,0,1-4.576.242,2.573,2.573,0,0,1-.668.086,2.623,2.623,0,0,1-2.474-3.49,3.277,3.277,0,0,1-.238-6.026,2.6,2.6,0,0,1-.565-1.626A2.627,2.627,0,0,1,3.376,5.3a2.561,2.561,0,0,1-.1-.713A2.629,2.629,0,0,1,5.256,2.044,2.3,2.3,0,0,1,7.538,0Zm5.9,0a2.3,2.3,0,0,1,2.282,2.044A2.62,2.62,0,0,1,17.7,4.588a2.561,2.561,0,0,1-.1.713,2.624,2.624,0,0,1,2.065,2.565A2.6,2.6,0,0,1,19.1,9.492a3.277,3.277,0,0,1-.238,6.026,2.623,2.623,0,0,1-2.474,3.49,2.573,2.573,0,0,1-.668-.086,2.294,2.294,0,0,1-4.576-.242V2.294A2.3,2.3,0,0,1,13.437,0Z",
    transform: "translate(14.683 113.451)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKnowledgeTransfer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/KnowledgeTransfer.f83bdf72b91f02af346f16f804b3af13.svg";